import Index from './Index.vue';
import TransferType from './TransferType';
import AdditionalOptions from './AdditionalOptions';
import Contact from './Contact';
import Summary from './Summary';

// export {Index};
export default {Index, TransferType, AdditionalOptions, Contact, Summary};
